class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.createSlider();
  }

  createSlider() {
    let drag = false;
    const slider = new KeenSlider(".related-products-slider", {
      dragChecked() {
        drag = true;
      },
      dragEnded() {
        setTimeout(() => (drag = false), 0);
      },
      created() {
        document.querySelector('.related-products-slider').addEventListener("click", (e) => {
          if (drag) {
            e.stopPropagation();
            e.preventDefault();
          }
        })
      },
      breakpoints: {
        '(max-width: 749px)': {
          slides: {
            perView: 2,
            spacing: 16
          }
        },
        '(min-width: 750px)': {
          slides: {
            perView: 3,
            spacing: 24
          }
        },
        '(min-width: 990px)': {
          disabled: true,
        },
      }
    }, [navigation]);
  }
}

customElements.define('related-products', RelatedProducts);